import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { socketConfig } from "app/services/socket";
import { getCurrentCustomerInfoId } from "app/services/socket";
import { logout } from "app/redux/authReducer";

export default function useSocketLogout() {
  const [socket, setSocket] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const socket = socketConfig();
    setSocket(socket);

    return () => {
      socket?.disconnect();
    };
  }, []);

  useEffect(() => {
    if (socket) {
      socket.on("user-deleted", ({ customerId }) => {
        if (customerId === getCurrentCustomerInfoId()) {
          dispatch(logout());
          navigate("/login");
        }
      });
    }

    return () => {
      socket?.off("user-deleted");
    };
  }, [socket, dispatch, navigate]);

  return socket;
}
